// wallets.actions.js

import { toast } from 'react-toastify';
import apiCall from "../../utils/apiCall";
import IPCAuth from "../../ICP/auth.utils";
import { getPhantomWalletAndProvider, signMessageWithPhantom, signMessageWithPhantomString } from '../../utils/WalletProviders/phantom';
import { getXverseWalletAndProvider, signMessageWithXverse } from '../../utils/WalletProviders/xVerse';
/* ---------------------------
   WalletGroup API Actions
----------------------------*/

// Get all WalletGroups.
export const getWalletGroups = (dispatch) => async () => {
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    const data = await apiCall('/walletgroups', 'GET', null);
    dispatch({ type: 'GET_WALLET_GROUPS', payload: data });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    dispatch({ type: "SET_LOADING", payload: false });
  }
};

// Add a new WalletGroup.
export const addWalletGroup = (dispatch) => async (walletGroup) => {
  const toastId = toast.loading("Adding Wallet Group...");
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    const data = await apiCall('/walletgroups', 'POST', walletGroup);
    dispatch({ type: 'ADD_WALLET_GROUP', payload: data });
    toast.update(toastId, {
      render: "Wallet group added successfully!",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    toast.update(toastId, {
      render: `Error adding wallet group: ${ error.message }`,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
    console.error('Add WalletGroup Error:', error);
  }
};

// Edit an existing WalletGroup.
export const editWalletGroup = (dispatch) => async (walletGroup) => {
  const toastId = toast.loading("Updating Wallet Group...");
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    const data = await apiCall(`/walletgroups/${ walletGroup._id }`, 'PUT', walletGroup);
    dispatch({ type: 'EDIT_WALLET_GROUP', payload: data });
    toast.update(toastId, {
      render: "Wallet group updated successfully!",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    toast.update(toastId, {
      render: `Error updating wallet group: ${ error.message }`,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
    console.error('Edit WalletGroup Error:', error);
  }
};

// Delete a WalletGroup.
export const deleteWalletGroup = (dispatch) => async (walletGroupId) => {
  const toastId = toast.loading("Deleting Wallet Group...");
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    await apiCall(`/walletgroups/${ walletGroupId }`, 'DELETE', null);
    dispatch({ type: 'DELETE_WALLET_GROUP', payload: walletGroupId });
    toast.update(toastId, {
      render: "Wallet group deleted successfully!",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    toast.update(toastId, {
      render: `Error deleting wallet group: ${ error.message }`,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
    console.error('Delete WalletGroup Error:', error);
  }
};

/* ---------------------------
   Wallet API Actions
----------------------------*/

// Get all Wallets.
export const getWallets = (dispatch) => async () => {
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    const data = await apiCall('/wallets', 'GET', null);
    dispatch({ type: 'GET_WALLETS', payload: data });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    dispatch({ type: "SET_LOADING", payload: false });
  }
};

// Add a new Wallet.
export const addWallet = (dispatch) => async (wallet) => {
  const toastId = toast.loading("Adding Wallet...");
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    const data = await apiCall('/wallets', 'POST', wallet);
    dispatch({ type: 'ADD_WALLET', payload: data });
    toast.update(toastId, {
      render: "Wallet added successfully!",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    toast.update(toastId, {
      render: `Error adding wallet: ${ error.message }`,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
    console.error('Add Wallet Error:', error);
  }
};

// Edit an existing Wallet.
export const editWallet = (dispatch) => async (wallet) => {
  const toastId = toast.loading("Updating Wallet...");
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    const data = await apiCall(`/wallets/${ wallet._id }`, 'PUT', wallet);
    dispatch({ type: 'EDIT_WALLET', payload: data });
    toast.update(toastId, {
      render: "Wallet updated successfully!",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    toast.update(toastId, {
      render: `Error updating wallet: ${ error.message }`,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
    console.error('Edit Wallet Error:', error);
  }
};

// Delete a Wallet.
export const deleteWallet = (dispatch) => async (walletId) => {
  const toastId = toast.loading("Deleting Wallet...");
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    await apiCall(`/wallets/${ walletId }`, 'DELETE', null);
    dispatch({ type: 'DELETE_WALLET', payload: walletId });
    toast.update(toastId, {
      render: "Wallet deleted successfully!",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    toast.update(toastId, {
      render: `Error deleting wallet: ${ error.message }`,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
    console.error('Delete Wallet Error:', error);
  }
};


//mainWallet
export const setMainWallet = (dispatch) => async (walletType) => {
  const toastId = toast.loading("Setting Main Wallet...");
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    const ipcAuth = new IPCAuth();

    console.log(ipcAuth, "ipcAuth");
    if (!ipcAuth.anonimousActor) {
      await ipcAuth.initializAnonimousActor();
    }
    let signature;
    let walletAddress;
    let walletProvider;
    let walletPublicKey;


    switch (walletType) {
      case "PHANTOM":
        let { address, provider, publicKey } = await getPhantomWalletAndProvider();
        walletAddress = address;
        walletProvider = provider;
        walletPublicKey = publicKey;
        break;
      case "XVERSE":
        let { address: xAddress, publicKey: xPublickey } = await getXverseWalletAndProvider();
        walletAddress = xAddress;
        walletPublicKey = xPublickey;
        break;
      default:
        throw new Error("Unsupported wallet type");
    }

    const result = await ipcAuth.anonimousActor.siwb_prepare_login(walletAddress); // Native segwit address
    const message = result.Ok;

    switch (walletType) {
      case "PHANTOM":
        signature = await signMessageWithPhantom({
          provider: walletProvider,
          address: walletAddress,
          message: message,
        });
        break;
      case "XVERSE":
        signature = await signMessageWithXverse(walletAddress, message);
        break;
    }

    console.log("Signature:", {
      address: walletAddress,
      signature: signature,
      publicKey: walletPublicKey,
    });

    let data = await ipcAuth.login({
      address: walletAddress,
      signature: signature,
      publicKey: walletPublicKey,
      type: walletType,
    });
    dispatch({ type: 'SET_MAIN_WALLET', payload: data });
    localStorage.setItem("mainWallet", JSON.stringify(data));
    toast.update(toastId, {
      render: "Main wallet set successfully!",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    toast.update(toastId, {
      render: `Error setting main wallet: ${ error.message }`,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
    console.error('Set Main Wallet Error:', error);
  }
};

export const removeMainWallet = (dispatch) => async () => {
  const toastId = toast.loading("Removing Main Wallet...");
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    localStorage.removeItem("mainWallet");
    dispatch({ type: 'REMOVE_MAIN_WALLET' });
    toast.update(toastId, {
      render: "Main wallet removed successfully!",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    toast.update(toastId, {
      render: `Error removing main wallet: ${ error.message }`,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
    console.error('Remove Main Wallet Error:', error);
  }
};